__turbopack_context__.v({
  "actionBtn": "CBrowserPressOnline-module__ouki5q__actionBtn",
  "actionBtnPrimary": "CBrowserPressOnline-module__ouki5q__actionBtnPrimary",
  "actions": "CBrowserPressOnline-module__ouki5q__actions",
  "bookNav": "CBrowserPressOnline-module__ouki5q__bookNav",
  "bookNavBtn": "CBrowserPressOnline-module__ouki5q__bookNavBtn",
  "bookNavInfo": "CBrowserPressOnline-module__ouki5q__bookNavInfo",
  "bookWrap": "CBrowserPressOnline-module__ouki5q__bookWrap",
  "countBadge": "CBrowserPressOnline-module__ouki5q__countBadge",
  "cover": "CBrowserPressOnline-module__ouki5q__cover",
  "coverPlaceholder": "CBrowserPressOnline-module__ouki5q__coverPlaceholder",
  "coverWrap": "CBrowserPressOnline-module__ouki5q__coverWrap",
  "empty": "CBrowserPressOnline-module__ouki5q__empty",
  "issueAppliesLine": "CBrowserPressOnline-module__ouki5q__issueAppliesLine",
  "issueBack": "CBrowserPressOnline-module__ouki5q__issueBack",
  "issueBackLink": "CBrowserPressOnline-module__ouki5q__issueBackLink",
  "issueCard": "CBrowserPressOnline-module__ouki5q__issueCard",
  "issueCardBody": "CBrowserPressOnline-module__ouki5q__issueCardBody",
  "issueCardLink": "CBrowserPressOnline-module__ouki5q__issueCardLink",
  "issueDates": "CBrowserPressOnline-module__ouki5q__issueDates",
  "issueDesc": "CBrowserPressOnline-module__ouki5q__issueDesc",
  "issueHeader": "CBrowserPressOnline-module__ouki5q__issueHeader",
  "issueLead": "CBrowserPressOnline-module__ouki5q__issueLead",
  "issueName": "CBrowserPressOnline-module__ouki5q__issueName",
  "issueTitle": "CBrowserPressOnline-module__ouki5q__issueTitle",
  "issues": "CBrowserPressOnline-module__ouki5q__issues",
  "page": "CBrowserPressOnline-module__ouki5q__page",
  "pageImg": "CBrowserPressOnline-module__ouki5q__pageImg",
  "pageNumber": "CBrowserPressOnline-module__ouki5q__pageNumber",
  "pageZoomBtn": "CBrowserPressOnline-module__ouki5q__pageZoomBtn",
  "root": "CBrowserPressOnline-module__ouki5q__root",
  "tag": "CBrowserPressOnline-module__ouki5q__tag",
  "tagPopup": "CBrowserPressOnline-module__ouki5q__tagPopup",
  "tagPopupTitle": "CBrowserPressOnline-module__ouki5q__tagPopupTitle",
  "tagsLayer": "CBrowserPressOnline-module__ouki5q__tagsLayer",
});
